"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationEnrichment = exports.getCategoryFullname = exports.default = void 0;
var _middlewares = require("../rooms/middlewares");
var _config = _interopRequireDefault(require("../../config"));
var _excluded = ["viewed"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var getCategoryFullname = _ref => {
  var {
    category,
    notificationType,
    read
  } = _ref;
  var name = "".concat(category);
  if (notificationType) {
    name = "".concat(name, "_").concat(notificationType);
  } else {
    name = "".concat(name, "_all");
  }
  if (read === false) {
    name = "".concat(name, "_unread");
  } else if (read === true) {
    name = "".concat(name, "_read");
  }
  return name;
};
exports.getCategoryFullname = getCategoryFullname;
var notificationEnrichment = exports.notificationEnrichment = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (_ref2) {
    var {
        notification: {
          viewed
        } = {},
        _client: _myClient,
        _user
      } = _ref2,
      notification = _objectWithoutProperties(_ref2.notification, _excluded);
    var newNotification;
    switch (notification.category) {
      case 'room':
        {
          var payload = yield (0, _middlewares.roomEnrichment)({
            room: notification.payload,
            _client: _myClient,
            _user,
            searchContact: true
          });
          if (_config.default.clearUnusedDataFromNotification) {
            newNotification = _objectSpread(_objectSpread({}, notification), {}, {
              payload: {
                caller: {
                  avatarUri: payload.caller.avatarUri,
                  fullname: payload.caller.fullname,
                  _user: payload.caller._user,
                  isMyUser: payload.caller.isMyUser,
                  phonenumber: payload.caller.phonenumber
                },
                duration: payload.duration,
                isVideoCall: payload.isVideoCall,
                isPrivate: payload.isPrivate,
                isMulticast: payload.isMulticast,
                members: payload.members.reduce((acc, _ref4) => {
                  var {
                    avatarUri,
                    fullname,
                    _user,
                    isMyUser,
                    phonenumber
                  } = _ref4;
                  if (!isMyUser) {
                    acc.push({
                      avatarUri,
                      fullname,
                      phonenumber,
                      _user
                    });
                  }
                  return acc;
                }, []),
                name: payload.name,
                _feed: payload._feed
              }
            });
            if (!newNotification.payload.members.length) {
              // if you called yourself, members will be empty
              newNotification.payload.members.push(newNotification.payload.caller);
            }
          } else {
            newNotification = _objectSpread(_objectSpread({}, notification), {}, {
              payload
            });
          }
          break;
        }
      default:
        newNotification = notification;
    }
    newNotification.read = viewed;
    return newNotification;
  });
  return function notificationEnrichment(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var _default = exports.default = {
  notificationEnrichment,
  getCategoryFullname
};